import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';

const PriceDisplay = ({
  price,
  currency,
  currencies,
  showTotal = false,
  totalPrice,
  showCustom = false,
  showUnit = true,
  sx = {},
}) => {
  const priceSx = {
    fontWeight: 'bold',
    color: '#0f172a',
    lineHeight: 1.1,
    ...sx,
  };

  if (showCustom && !price) {
    return (
      <Typography variant="h4" sx={priceSx} className="tabular-nums">
        Custom
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        alignItems: 'center',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
        <Typography variant="h4" sx={priceSx} className="tabular-nums">
          {currencies[currency].symbol}
          {price?.toLocaleString()}
        </Typography>
        {showUnit && (
          <Typography variant="body2" color="text.secondary">
            /report
          </Typography>
        )}
      </Box>
      {showTotal && totalPrice && (
        <Typography variant="body2" color="text.secondary" className="tabular-nums">
          Total: {currencies[currency].symbol}
          {totalPrice.toLocaleString()}
        </Typography>
      )}
    </Box>
  );
};

PriceDisplay.propTypes = {
  price: PropTypes.number,
  currency: PropTypes.string.isRequired,
  currencies: PropTypes.objectOf(
    PropTypes.shape({
      symbol: PropTypes.string.isRequired,
    }),
  ).isRequired,
  showTotal: PropTypes.bool,
  totalPrice: PropTypes.number,
  showCustom: PropTypes.bool,
  showUnit: PropTypes.bool,
  sx: PropTypes.object,
};

export default PriceDisplay;
